export default "__VITE_ASSET__BSGEEY$f__"